import { CheckboxOption } from '@employ-engage/data';
import {} from '@headlessui/react';
import ErrorMessage from '../error-message/error-message';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export interface EECheckboxGroupProps {
  value?: any;
  onChange?: (val: any, option: CheckboxOption) => void;
  options: CheckboxOption[];
  errors?: any;
  touched?: boolean;
  previewOnly?: boolean;
  optionLabelClass?: string;
}

export function EECheckboxGroup({
  value,
  onChange,
  options,
  errors,
  touched,
  previewOnly,
  optionLabelClass,
}: EECheckboxGroupProps) {
  const { t } = useTranslation(['common']);
  return (
    <fieldset>
      <legend className="sr-only">{t('Notifications')}</legend>
      <div className="space-y-2">
        {options.map((option) => {
          return (
            <div className="relative flex items-start" key={option.id}>
              <div className="flex h-6 items-center">
                <input
                  id={option.id}
                  name={option.id}
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                  onChange={(e: any) => onChange?.(e, option)}
                  checked={value?.subAnswers.some((subAnswer: any) => {
                    return subAnswer.id === option.id;
                  })}
                  disabled={previewOnly}
                />
              </div>
              <div className="ml-3 text-sm leading-6">
                <label
                  htmlFor={option.id}
                  className={classNames(
                    'font-medium',
                    optionLabelClass ? optionLabelClass : 'text-white'
                  )}
                >
                  {option.label}
                </label>
              </div>
            </div>
          );
        })}
        <ErrorMessage errors={errors} touched={touched} />
      </div>
    </fieldset>
  );
}

export default EECheckboxGroup;
